import { bindActionCreators } from 'redux'
import { forgotPasswordAttempt } from '../../actions'

const mapDispatchToProps = dispatch => bindActionCreators({ forgotPasswordAttempt }, dispatch)

export default mapDispatchToProps
